<!-- <div class="all-members-card">
  <div class="heading">
    <div class="heading-left">Family Members</div>
    <div class="heading-right" (click)="redirectToAddMembers()"> + <div>Add Members</div> </div>
  </div>


 <div class="loading-text" *ngIf="isLoading">
  
<div class=" skel"></div>
<div class=" skel"></div>
<div class=" skel"></div>

 </div>
<div class="members-grid" *ngIf="!isLoading">
    <div class="single-member-card" *ngFor="let member of family">
      <div class="profile-pic">
        <img src="../../../../assets/images/adult-female-profile-pic.png" alt="" *ngIf="member.sex === 'F' && member.relationShipId === 'SPOUSE'">
        <img src="../../../../assets/images/adult-male-profile-pic.png" alt="" *ngIf="member.sex === 'M' && member.relationShipId === 'HUSBAND'">
        <img src="../../../../assets/images/adult-male-profile-pic.png" alt="" *ngIf="member.sex === 'F' && member.relationShipId === 'DAUGHTER'">
        <img src="../../../../assets/images/son-profile-pic.png" alt="" *ngIf="member.sex === 'M' && member.relationShipId === 'SON'">
        <img src="../../../../assets/images/adult-male-profile-pic.png" alt="" *ngIf="member.sex === 'M' && memberrelationShipId.toUpperCase() === 'SELF'">
        <img src="../../../../assets/images/adult-female-profile-pic.png" alt="" *ngIf="member.sex === 'F' && memberrelationShipId.toUpperCase() === 'SELF'">
      </div>

      <div class="details">
        <div class="member-name">{{ member.insuredName }}</div>
        <div class="member-about">
          {{ member.relationShipId }} | {{ member.age }} Years | {{ member.sex }}
        </div>
      </div>
    </div>
</div>

</div> -->
<div class="claims-wrapper">
  <div class="claims-header" (click)="goBack()">
    <img src="../../../../assets/images/arrow-right.png" alt="">
    Manage Profile
  </div>

  <div class="claims-body">
    <div class="claims-body">
      <div class="heading">
        <div class="img">
          <img src="../../../../assets/images/adult-male-profile-pic.png" alt="" *ngIf="memberSelf.sex === 'M'">
          <img src="../../../../assets/images/Spouse.png" alt="" *ngIf="memberSelf.sex === 'F'">
        </div>
        <div class="desc">
          <div class="name">{{ memberSelf.insuredName }}</div>
          <div class="empid"> Employee ID: {{ memberSelf.memberIdEmpId }} </div>
        </div>
      </div>
      <div class="details">
        Employee Details
        <ul>
          <li>
            <div class="field-name mr-2 label">Mobile:</div>
            <div class="field-data" *ngIf="memberSelf.mobileNo">{{ memberSelf.mobileNo }}
              <!-- <img src="../../../../assets/icons/greenTickLogo.png" alt=""> -->
            </div>
          </li>
          <li class="w-100">
            <div class="field-name mr-2 label">Email:</div>
            <div class="field-data" *ngIf="memberSelf.emailID">{{ memberSelf.emailID }}
              <!-- <img src="../../../../assets/icons/greenTickLogo.png" alt=""> -->
            </div>
          </li>
          <li class="w-100">
            <div class="field-name mr-2 label">Date of Birth:</div>
            <div class="field-data">{{ memberSelf.dob | date}}</div>
          </li>
          <li class="w-100">
            <div class="field-name mr-2 label">Gender:</div>
            <div class="field-data">{{ memberSelf.sex  == 'M' ? 'Male' : 'Female' }}</div>
          </li>
          <li class="w-100">
            <div class="field-name mr-2 label">Date of Joining:</div>
            <div class="field-data">{{ memberSelf.doj | date }} </div>
          </li>
          <li class="w-100">
            <div class="field-name mr-2 label">Address:</div>
            <div class="field-data">{{ memberSelf.address1 }} </div>
          </li>

          <li class="w-100">
            <div class="field-name mr-2 label">Relationship:</div>
            <div class="field-data" *ngIf="memberSelf.age">Self </div>
          </li>
          <li class="w-100">
            <div class="field-name mr-2 label">Age:</div>
            <div class="field-data" *ngIf="memberSelf.age">{{ memberSelf.age }} Years </div>
          </li>
          <li class="w-100">
            <div class="field-name mr-2 label">Abha number:</div>
            <div class="field-data">{{ memberSelf.insuredABHAId }}</div>
          </li>
          <li class="w-100">
            <div class="field-name mr-2 label">Abha Address:</div>
            <div class="field-data">{{ memberSelf.insuredABHAAddress }}</div>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <app-active-sessions></app-active-sessions>
    </div>

  </div>


<div class="start-tarack-claim-wrapper">
  <div class="button-text" (click)="signout()"><img src="../../../../assets/icons/logoutIcon.png" alt="" width="18">Log out</div>
</div>
</div>